var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":""}},[_c('v-toolbar-title',[_vm._v("Application")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }